/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Max_Duration_LabelInputs */

const en_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Event Duration (sec)`)
};

const fr_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée maximale de l'événement (sec)`)
};

const de_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Ereignisdauer (Sek.)`)
};

const it_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata massima dell'evento (sec)`)
};

const ru_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная продолжительность события (сек)`)
};

const es_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración máxima del evento (seg.)`)
};

const zh_cn2_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件最大持续时间（秒）`)
};

const ja_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大イベント継続時間（秒）`)
};

const hi_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम घटना अवधि (सेकंड)`)
};

const pt_pt2_edit_event_group_max_duration_label = /** @type {(inputs: Edit_Event_Group_Max_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração máxima do evento (seg)`)
};

/**
* | output |
* | --- |
* | "Maximum Event Duration (sec)" |
*
* @param {Edit_Event_Group_Max_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_max_duration_label = /** @type {((inputs?: Edit_Event_Group_Max_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Max_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_max_duration_label(inputs)
	if (locale === "de") return de_edit_event_group_max_duration_label(inputs)
	if (locale === "it") return it_edit_event_group_max_duration_label(inputs)
	if (locale === "ru") return ru_edit_event_group_max_duration_label(inputs)
	if (locale === "es") return es_edit_event_group_max_duration_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_max_duration_label(inputs)
	if (locale === "ja") return ja_edit_event_group_max_duration_label(inputs)
	if (locale === "hi") return hi_edit_event_group_max_duration_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_max_duration_label(inputs)
	return en_edit_event_group_max_duration_label(inputs)
});